import { Label, Input, FormFeedback } from 'reactstrap';
import { useField } from 'formik';
import PropTypes from 'prop-types';

const FormikField = (props) => {
  const { label, name } = props;
  const [field, meta, helpers] = useField(props);

  return (
    <div className="mb-md-6 mb-1">
      <Label className="form-label" for={name}>
        {label}
      </Label>
      <Input
        id={name}
        //value={formik.values[name]}
        //onChange={formik.handleChange}
        //onBlur={formik.handleBlur}
        //error={formik.touched[name] && Boolean(formik.errors[name])}
        {...field}
        {...props}
      />

      {/* <FormFeedback valid={meta.touched && Boolean(meta.errors)}>{meta.error[name]}</FormFeedback> */}
    </div>
  );
};

FormikField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string
};

FormikField.defaultProps = {
  type: 'text'
};

export default FormikField;
